import { Navigate, useLocation } from 'react-router-dom';
import { NotFoundPage } from '@/components/pages/WorkspaceStatusPage';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';
import { useAppSelector } from '@/hooks/useAppSelector';

/** Fallback for unknown routes outside the workspace shell (auth pages, etc.). */
export function UnknownRouteHandler() {
  const location = useLocation();
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={MODULE_HUB_PATH} state={{ from: location }} replace />;
  }

  return <NotFoundPage />;
}
